// Optimised magnify.js with forced reflow fixes
// Restored original functionality with performance optimisations

let overlay = null;
let cachedMeasurements = null;

function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  // Use cached measurements to avoid forced reflows
  if (!cachedMeasurements) {
    cachedMeasurements = {
      ratio: image.height / image.width,
      imageWidth: image.clientWidth,
      imageHeight: image.height,
    };
  }

  const { ratio, imageWidth, imageHeight } = cachedMeasurements;
  
  // Handle both mouse and touch events
  const clientX = event.clientX || (event.touches && event.touches[0].clientX);
  const clientY = event.clientY || (event.touches && event.touches[0].clientY);
  
  // Batch DOM reads
  const container = event.target.getBoundingClientRect();
  const xPosition = clientX - container.left;
  const yPosition = clientY - container.top;
  const xPercent = `${xPosition / (imageWidth / 100)}%`;
  const yPercent = `${yPosition / ((imageWidth * ratio) / 100)}%`;

  // Batch DOM writes
  requestAnimationFrame(() => {
    overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
    overlay.style.backgroundSize = `${imageWidth * zoomRatio}px`;
  });
}

function magnify(image, zoomRatio) {
  // Remove any existing zoom overlays first
  const existingOverlays = document.querySelectorAll('.image-magnify-full-size');
  existingOverlays.forEach(overlay => overlay.remove());
  
  // Reset cached measurements for new image
  cachedMeasurements = null;
  
  const newOverlay = createOverlay(image);
  newOverlay.onclick = () => {
    newOverlay.remove();
    cachedMeasurements = null;
  };
  newOverlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  newOverlay.onmouseleave = () => {
    newOverlay.remove();
    cachedMeasurements = null;
  };
  
  // Add touch support for mobile
  newOverlay.ontouchmove = (event) => {
    event.preventDefault();
    moveWithHover(image, event, zoomRatio);
  };
  newOverlay.ontouchend = () => {
    newOverlay.remove();
    cachedMeasurements = null;
  };
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onclick = (event) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });
}

// Initialize zoom functionality
enableZoomOnHover(2);
